import React from 'react';
import { TrendingStockModel } from './TrendindstockModel';


const TrendingStocks = () => {
    const trendingStockModel = TrendingStockModel()
    return (
        <div className="card">
            <div className="card-head">
                <h5 className="card-title ps-3 border-bottom_card mb-3">Trending</h5>
            </div>
            <div className="card-body pt-0">
                <div className="row">
                    <div className="col-md-12 mb-3">
                        <input type="text" className="form-control" placeholder='Search' 
                        onChange={trendingStockModel.handleChange}/>
                    </div>
                </div>
                {
                    trendingStockModel.filteredTrendingStocks && trendingStockModel.filteredTrendingStocks.map((d: any, index: number) => (
                        <div className="row border-bottom_card" key={index} onClick={(e)=>trendingStockModel.viewStockDetails(d)}>
                            <div className="col-6">
                                <p className="trending_text text-start mt-2">{d.symbol}</p>
                                <p className="trending_text1 mt-1 text-start">{d.name}</p>
                            </div>
                            <div className="col-6 text-end my-auto">
                                <p className="trending_text">{d.lastSale}</p>
                                <p className={(+d.netChange) > 0 ? 'color_percent1' : 'color_percent'}>{d.netChange} ({d.perChange})</p>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default TrendingStocks;